export const enum ANumberMutationsNames {
    SetANumberAssignments = "setANumberAssignments",
    SetANumberGroupList = "setANumberGroups",
    SetSelectedANumberGroup = "setSelectedANumberGroup",
    SetSelectedANumberAssignment = "setSelectedANumberAssignment",
    SetANumberAssignmentError = "setANumberAssignmentError",
    SetANumberGroupError = "setANumberGroupError",
    ResetState = "resetState",
}

export const enum ANumberActionsNames {
    FetchANumberAssignmentsList = "fetchANumberAssignmentsList",
    FetchANumberGroupList = "fetchANumberGroupList",
    SetSelectedANumberAssignment = "setSelectedANumberAssignment",
    SetSelectedANumberGroup = "setSelectedANumberGroup",
    SetANumberAssignments = "setANumberAssignments",
    ResetState = "resetANumberState",
}

export const enum ANumberGettersNames {
    ANumberAssignmentsList = "aNumberAssignmentsList",
    ANumberGroupList = "aNumberGroupsList",
    SelectedANumberAssignment = "selectedANumberAssignnment",
    SelectedANumberGroup = "selectedANumberGroup",
}
